import {Status as AutomationFileStatusGraphQL} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingAction} from 'redux-stores/Action';

import {AutomationFileStatusActionType} from './AutomationFileActions';

/**
 * Reducer for tracking the status of automation files
 */

export type AutomationFileStatusState = Record<string, AutomationFileStatusGraphQL>;

function setAutomationFileStatus(
  state: AutomationFileStatusState,
  automationFileId: string,
  automationFileStatus: AutomationFileStatusGraphQL
): AutomationFileStatusState {
  return {
    ...state,
    [automationFileId]: automationFileStatus,
  };
}

export default function reduceAutomationFileStatus(
  state: AutomationFileStatusState = {},
  action: BenchlingAction
): AutomationFileStatusState {
  switch (action.type) {
    case AutomationFileStatusActionType.SET_AUTOMATION_FILE_STATUS: {
      return setAutomationFileStatus(state, action.automationFileId, action.automationFileStatus);
    }

    default:
      return state;
  }
}
